import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { Checkbox, CrudForm, useEntityManager } from 'elentari'
import listaAvisoRepository from './listaAvisoRepository'
import { parseCpfOrCnpj } from '../../../utils/Parse'
import { CustomTextField } from '../../../components/CustomDisabledFields'
import { validateCpfOrCnpj } from '../../../utils/Validators'
import CorAvisoSelect from './CorAvisoSelect'

const validate = data => ({
  cpfCnpj: data.cpfCnpj && validateCpfOrCnpj(data.cpfCnpj),
  descricao: data.descricao ? undefined : 'Obrigatório',
  cor: data.cor ? undefined : 'Obrigatório'
})

const ListaAvisoForm = props => {
  const entityManager = useEntityManager({
    repository: listaAvisoRepository
  })

  const handleSubmit = data => {
    return entityManager.onSubmit({
      descricao: data.descricao,
      cor: data.cor,
      cpfCnpj: data.cpfCnpj.replace(/[^\d]/g, ''),
      confiavel: data.cor === 'success' && data.confiavel,
      anttArrendada: data.cor !== 'success' && data.anttArrendada
    })
  }

  const renderContent = ({ values }) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            name="cpfCnpj"
            component={CustomTextField}
            InputLabelProps={{ shrink: true }}
            format={parseCpfOrCnpj}
            label="CPF / CNPJ"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Field
            fullWidth
            name="descricao"
            component={CustomTextField}
            label="Descrição"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CorAvisoSelect />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            component={Checkbox}
            label="Confiável"
            name="confiavel"
            type="checkbox"
            disabled={values.cor !== 'success'}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            component={Checkbox}
            label="ANTT Arrendada"
            name="anttArrendada"
            type="checkbox"
            disabled={values.cor === 'success'}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={validate}
      withPaper
    >
      {renderContent}
    </CrudForm>
  )
}

export default ListaAvisoForm
